import { tns } from 'tiny-slider';

export function heroSlider() {
    let slider = document.getElementById('hero-slider');
    if (slider) {
        slider = tns({
            container: '#hero-slider',
            items: 1,
            gutter: 2,
            autoplay: true,
            speed: 2000,
            autoplaySpeed: 2500,
            autoplayTimeout: 6000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: false,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                576: {
                    items: 2
                },
                768: {
                    items: 3,
                },
            }
        });
    }
    return 'heroSlider';
}



export function meerActiviteitenSlider() {
    let slider = document.getElementById('meer-activiteiten-slider');
    if (slider) {
        slider = tns({
            container: '#meer-activiteiten-slider',
            items: 1.25,
            gutter: 8,
            autoplay: true,
            speed: 2000,
            autoplaySpeed: 2500,
            autoplayTimeout: 6000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: false,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                450: {
                    items: 1.5
                },
                576: {
                    items: 2
                },
                768: {
                    items: 3,
                },
                1024: {
                    items: 2,
                },
                1366: {
                    items: 3
                }
            }
        });
    }
    return 'meerActiviteitenSlider';
}
